class PurchaseOrderReportController extends AbstractController
	@register()
	@inject 'stockLocations',
		'shops'
		'suppliers'

	initialize: ->
		@purchaseOrderReportSettings =
			isNewEntity: true
			showAsReport: true
			isLocked: false
